import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import CreateUser from './CreateUser'
import './style.scss'
import BlockModal from './Modals/BlockModal'
import UnBlockModal from './Modals/UnBlockModal'
import DeatilsModal from './Modals/DeatilsModal'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllUsers } from '../../../redux/action/adminProfile/admin-profile'
import MainLoading from '../../../utils/MainLoading'
import { useTranslation } from 'react-i18next'

const DashboardUsersManagement = ({history}) => {
    const [newUser, setNewUser] = useState(false)
    const [show, setShow] = useState(true);
    const [forceUpdate, setForceUpdate] = useState(0)
    const [modal, setModal] = useState({
        delete: false,
        block: false,
        unblock: false,
        details: false,
        id: ''
    })
    const dispatch = useDispatch()
    const users = useSelector(state => state.all_users)
    const {t} = useTranslation();

    const createNewUser = () => { 
        setNewUser(true) 
        window.scrollTo(0, 700)
    }
    const handleClick = () => { setShow(false) }

    const handleBlock = (id) => { {
        setModal({  block: true, id: id })
        setShow(true)
    }}

    const handleUnBlock = (id) => { {
        setModal({ unblock: true, id: id })
        setShow(true)
    }}

    const handleDetails = (id) => {
        setModal({ details: true, id: id })
        setShow(true)
    }

    const update = () => {
        setForceUpdate(1)
        setShow(false)
        setNewUser(false) 
        setTimeout(() => {
            dispatch(fetchAllUsers())
        }, 1000)
    }

    useEffect(() => {
        dispatch(fetchAllUsers())
    }, [forceUpdate])

    return (
        <Wrapper>
            <DashboardContent>
            <DashboardMainTitle> {t("dashboard_nav_users_management")} </DashboardMainTitle>
                {users.loading ? 
                    <MainLoading />
                :
                    users.data.admin &&
                        users.data.admin.length ?
                            <div className='halls_table'>
                                <Table responsive bordered>
                                    <thead>
                                    <tr>
                                        <th className='text-center col-4'>{t("username")}</th>
                                        <th className='text-center col-2'>{t("situation")}</th>
                                        <th className='text-center col-2'>{t("details")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {users.data.admin ?
                                            users.data.admin.map(item => (
                                                <tr key={item.id} id={item.id}>
                                                    <td>{item.username}</td>
                                                    <td className='text-center'>
                                                        {item.is_block ?
                                                            <button className='btn btn-success btn-sm px-3' onClick={id => handleUnBlock(item.id)}>{t("unblock company")}</button>
                                                        :
                                                            <button className='btn btn-danger btn-sm px-3' onClick={id => handleBlock(item.id)}>{t("block company")}</button>
                                                        }
                                                    </td>
                                                    <td className='text-center'><button className='btn btn-warning btn-sm px-3' onClick={id => handleDetails(item.id)}>{t("details")}</button></td>
                                                </tr>
                                            ))
                                        : <tr><td>{t("There is no user")}</td></tr>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        :
                            <h6 className='text-center'>{t("There is no user")}</h6>
                }
                <div className="col-12 create_btn my-5 d-flex justify-content-end">
                    <button className="btn btn-success" onClick={createNewUser}> {t("create new user")} <i className="fa fa-plus"></i></button>
                </div>
                {newUser ? 
                    <CreateUser />
                :
                    ''
                }
            </DashboardContent>
            {modal.block && <BlockModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.unblock && <UnBlockModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.details && <DeatilsModal id={modal.id} show={show} handleClick={handleClick} update={update} />}

        </Wrapper>
    )
}

export default DashboardUsersManagement
